export default class AlertService {
  private readonly url = "/api/alertecomponent"

  async createAlert(alert: any, antiForgeryToken: string): Promise<any> {
    const initConfig: RequestInit = {
      method: "POST",
      headers: {
        "content-type": "application/json; charset=utf-8",
        Hwantiforgerytoken: antiForgeryToken,
      },
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      body: JSON.stringify(alert),
    }

    const response = await fetch(this.addTimestampToUrl(this.url), initConfig)
    return response.status === 400
      ? Promise.reject(await response.text())
      : await response.json()
  }

  async deleteAlert(id: string): Promise<any> {
    const initConfig: RequestInit = {
      method: "DELETE",
      headers: {
        "content-type": "application/json; charset=utf-8",
      },
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
    }

    const response = await fetch(
      `${this.addTimestampToUrl(this.url)}&id=${id}`,
      initConfig,
    )
    return response.status === 400
      ? Promise.reject(await response.text())
      : await response.json()
  }

  async updateAlert(alert: any): Promise<any> {
    const initConfig: RequestInit = {
      method: "PUT",
      headers: {
        "content-type": "application/json; charset=utf-8",
      },
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      body: JSON.stringify(alert),
    }

    const response = await fetch(this.addTimestampToUrl(this.url), initConfig)
    return response.status === 400
      ? Promise.reject(await response.text())
      : await response.json()
  }

  async toggleAlert(payload: any, antiForgeryToken: string): Promise<any> {
    const initConfig: RequestInit = {
      method: "POST",
      headers: {
        "content-type": "application/json; charset=utf-8",
        Hwantiforgerytoken: antiForgeryToken,
      },
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      body: JSON.stringify(payload),
    }

    const response = await fetch(this.addTimestampToUrl(this.url), initConfig)
    return response.status === 400
      ? Promise.reject(await response.text())
      : await response.json()
  }

  private addTimestampToUrl(url: string): string {
    return `${url}?timestamp=${new Date().valueOf().toString()}`
  }
}
